
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[curriculumId]",
      function () {
        return require("private-next-pages/[curriculumId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[curriculumId]"])
      });
    }
  